// Generated by scripts/build-ui-icons.mjs.
export { MagnifyingGlass as default } from "../ui/glyphs-5";
